import React from 'react';
import { CTAButton, Section, BOOK_COVER } from './ui';
import { AlertTriangle, TrendingDown, BrainCircuit, Target, XCircle, ArrowRight } from 'lucide-react';
export function TopBar() {
  return <div className="bg-amber-500 text-amber-950 px-4 py-3 text-center font-semibold text-sm md:text-base sticky top-0 z-50 shadow-md" data-id="element-17">
      <p data-id="element-18">
        🔥 OFERTA ESPECIAL: 50% de descuento por tiempo limitado.{' '}
        <a href="#oferta" className="underline font-bold ml-2" data-id="element-19">
          Aprovechar ahora
        </a>
      </p>
    </div>;
}
export function Hero() {
  return <section className="relative pt-20 pb-24 md:pt-32 md:pb-32 px-4 sm:px-6 lg:px-8 bg-dark-bg overflow-hidden" data-id="element-20">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-50" data-id="element-21"></div>

      {/* Glow Effect */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-500/20 blur-[120px] rounded-full pointer-events-none" data-id="element-22"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-23">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-24">
          <div className="text-center md:text-left" data-id="element-25">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-brand-500/10 text-brand-500 text-sm font-bold mb-6 border border-brand-500/20" data-id="element-26">
              <span className="flex w-2 h-2 rounded-full bg-brand-500 mr-2 animate-pulse" data-id="element-27"></span>
              Para Traders que buscan consistencia
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white leading-tight mb-6" data-id="element-28">
              Dejá de regalarle plata al mercado por operar{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-400 to-emerald-600" data-id="element-29">
                sin un plan claro.
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto md:mx-0" data-id="element-30">
              Convertí tu estrategia en datos antes de arriesgar. Aprendé a
              validar tu sistema con backtesting de forma clara y objetiva.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4" data-id="element-31">
              <CTAButton size="xl" data-id="element-32">Quiero empezar a medir</CTAButton>
            </div>

            <div className="mt-8 flex items-center justify-center md:justify-start gap-4 text-sm text-gray-400" data-id="element-33">
              <div className="flex -space-x-2" data-id="element-34">
                {[1, 2, 3, 4].map(i => <img key={i} className="w-8 h-8 rounded-full border-2 border-dark-bg" src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="Trader" data-id="element-35" />)}
              </div>
              <p data-id="element-36">+500 traders ya validaron su estrategia</p>
            </div>
          </div>

          <div className="relative mx-auto w-full max-w-sm md:max-w-md" data-id="element-37">
            <div className="absolute -inset-4 bg-brand-500/20 blur-3xl rounded-full pointer-events-none" data-id="element-38"></div>
            <img src={BOOK_COVER} alt="Portada del ebook La Biblia del Backtest" className="relative w-full rounded-xl shadow-2xl border border-brand-500/20 transform -rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-39" />
          </div>
        </div>
      </div>
    </section>;
}
export function Problem() {
  const problems = [{
    icon: <BrainCircuit className="w-6 h-6 text-amber-500" data-id="element-40" />,
    text: 'En demo ejecutás perfecto, pero cuando hay dinero real en juego te bloqueás, dudás o cerrás antes.'
  }, {
    icon: <Target className="w-6 h-6 text-amber-500" data-id="element-41" />,
    text: 'Tenés una estrategia, pero en el fondo no sabés si realmente funciona o si solo estás confiando en unas pocas operaciones buenas.'
  }, {
    icon: <TrendingDown className="w-6 h-6 text-amber-500" data-id="element-42" />,
    text: 'Te cuesta sostener tus operaciones porque el miedo, la ansiedad o el FOMO terminan decidiendo por vos.'
  }, {
    icon: <XCircle className="w-6 h-6 text-amber-500" data-id="element-43" />,
    text: 'Cada mala racha te hace pensar que tu estrategia no sirve y volvés a empezar desde cero.'
  }];
  return <Section darker data-id="element-44">
      <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-45">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-500/10 text-amber-500 mb-6" data-id="element-46">
          <AlertTriangle className="w-8 h-8" data-id="element-47" />
        </div>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-48">
          Seguro te pasó que...
        </h2>
        <p className="text-xl text-gray-400" data-id="element-49">
          Sentís que estás entrando al mercado más por intuición que por un plan
          claro respaldado por datos.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-50">
        {problems.map((prob, idx) => <div key={idx} className="bg-dark-card border border-dark-border p-6 rounded-xl flex items-start gap-4 hover:border-amber-500/30 transition-colors" data-id="element-51">
            <div className="mt-1 flex-shrink-0" data-id="element-52">{prob.icon}</div>
            <p className="text-gray-300 leading-relaxed" data-id="element-53">{prob.text}</p>
          </div>)}
      </div>

      <div className="mt-16 text-center max-w-3xl mx-auto bg-brand-900/20 border border-brand-500/20 p-8 rounded-2xl" data-id="element-54">
        <p className="text-lg md:text-xl text-white font-medium" data-id="element-55">
          Aprendé a validar tu estrategia con backtesting de forma clara y
          objetiva,{' '}
          <span className="text-brand-400 font-bold" data-id="element-56">
            sin seguir regalándole plata al mercado
          </span>{' '}
          por operar sin un plan.
        </p>
      </div>
    </Section>;
}
export function Transformation() {
  return <Section data-id="element-57">
      <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-58">
        <div className="order-2 md:order-1 relative" data-id="element-59">
          <div className="aspect-square rounded-2xl overflow-hidden relative" data-id="element-60">
            <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Trader analizando gráficos con calma" className="object-cover w-full h-full opacity-80" data-id="element-61" />
            <div className="absolute inset-0 bg-gradient-to-t from-dark-bg via-transparent to-transparent" data-id="element-62"></div>
          </div>

          {/* Floating Card */}
          <div className="absolute -bottom-8 -right-8 bg-dark-card border border-dark-border p-6 rounded-xl shadow-2xl max-w-xs hidden md:block" data-id="element-63">
            <div className="flex items-center gap-4 mb-2" data-id="element-64">
              <div className="w-3 h-3 rounded-full bg-brand-500" data-id="element-65"></div>
              <p className="font-heading font-bold text-white" data-id="element-66">
                Setup Confirmado
              </p>
            </div>
            <p className="text-sm text-gray-400" data-id="element-67">
              Ejecución basada en datos, sin emociones.
            </p>
          </div>
        </div>

        <div className="order-1 md:order-2" data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-69">
            Imaginá sentarte frente al gráfico y sentir que{' '}
            <span className="text-brand-500" data-id="element-70">
              ya no estás entrando a ciegas.
            </span>
          </h2>
          <p className="text-lg text-gray-300 mb-8" data-id="element-71">
            Que cada operación deja de ser una mezcla de ansiedad, esperanza y
            miedo, y empieza a tener un porqué claro.
          </p>

          <div className="space-y-4 mb-10" data-id="element-72">
            {['Sé qué estoy buscando', 'Sé cuándo una entrada es válida', 'Sé cuándo me conviene esperar', 'Sé cuándo una pérdida fue parte del sistema', 'Sé cuándo el error fui yo rompiendo mis reglas', 'Sé qué datos necesito mirar antes de volver a arriesgar'].map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-73">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-500/20 flex items-center justify-center" data-id="element-74">
                  <ArrowRight className="w-4 h-4 text-brand-500" data-id="element-75" />
                </div>
                <p className="text-gray-200 font-medium" data-id="element-76">{item}</p>
              </div>)}
          </div>

          <p className="text-gray-400 italic border-l-4 border-brand-500 pl-4" data-id="element-77">
            Pasás de operar con la cabeza llena de dudas a tener un proceso. De
            perseguir movimientos a esperar tus condiciones.
          </p>
        </div>
      </div>
    </Section>;
}